import { PolarisIcon } from '@/exports/columnCommonComponents';
import { useAppDispatch } from '@/redux/hooks';
import { applyFilter, clearFilters, setCurrentTable } from '@/redux/slices/dataTableSlice';
import { OrderJobTask } from '@/redux/slices/slice_types';
import { IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';

interface TaskCardLinkProps {
  task: OrderJobTask;
}

const TaskCardLink = ({ task }: TaskCardLinkProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const onTaskClick = () => {
    if (!task?.hid || !task?.id) {
      console.log('task has no HID!');
      return null;
    }
    dispatch(setCurrentTable('tasks'));
    dispatch(clearFilters());
    dispatch(applyFilter({ type: 'filter_id', selections: [task.hid, 'task_hid_filter'] }));

    if (task.status === 'not_ready') dispatch(applyFilter({ type: 'show_not_ready', selections: true }));
    history.push(`/tasks/?id=${task.id}`);
  };

  return (
    <IconButton size="small" sx={{ marginLeft: 'auto', lineHeight: 1 }} onClick={onTaskClick} color="info">
      <PolarisIcon icon="external_link" height={20} />
    </IconButton>
  );
};

export default TaskCardLink;
